import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=5623c798&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=5623c798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623c798",
  null
  
)

export default component.exports